export default __webpack_public_path__ + "static/media/leftVector.0aa945f2.svg";